import globalEvents = require('diy/util/globalEvents');
import $ = require("jquery");

export interface IObserver {
    notify(data: any): Promise<boolean>;
}
export class Observable {

    private observers = new Set<IObserver>();

    registerObserver(o: IObserver) {
        this.observers.add(o);
    }

    unregisterObserver(o: IObserver) {
        this.observers.delete(o);
    }

    notify(data: any) {
        let promises: Promise<boolean>[] = [];
        this.observers.forEach(function(obs) {
            promises.push(obs.notify(data));
        });
        return promises;
    }
}

// well, i know this shouldn't be here
export class TrackerKPI implements IObserver {
    notify(data: any) {
        return new Promise(function(res) {
            if (data.eventName) {
                globalEvents.trigger(data.eventName, data);
                res(true);
            }
            res(false);
        });
    }
}

// this shouldn't be here either ... but where else ?
export class TrackerExperimentActivityLog implements IObserver {
    notify(data: any) {
        return new Promise(function(res) {
            if (data.activity) {
                $.ajax({
                    url: cc_.properties.cmsUrl + 'app/cms/tracking/track-experiment-activity',
                    type: 'get',
                    data: {
                        activity: data.activity
                    },
                    success: function() {
                        res(true);
                    },
                    error: function() {
                        res(false);
                    }
                });
            } else {
                res(false);
            }
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/Observable.ts
 **/